import { defineStore } from 'pinia'

export const useNotificationsStore = defineStore({
    id: 'notifications',

    state () {
        return {
            notifications: [],
            unreadCount: 0,
            length: 0,
            loading: true,
            hydrated: false
        }
    },

    actions: {   
        setUnread (val) {
            this.unreadCount = val;

            if (val) this.setBadge(val);
            else this.clearBadge();
        },

        add (notification) {
            if (!this.hydrated) return;
    
            if (!this.notifications.some(o => o.id == notification.id) ) {
                notification.read = !!notification.read
                this.notifications.unshift(notification);
            }
        },
        
        async hydrate() {
            // Prevent request for non logined users
            if (!this.$nuxt.$auth.user) return this.hydrated = true;
    
            let data = await this.$nuxt.$axios.$get('/notification/find', {
                progress: false,
                params: {
                    limit: 20
                }
            })
            .catch((err) => console.log(err));
    
            if (data) {
                let notifications = data.notifications.map(o => {
                    o.read = !!o.read;
                    return o;
                });
                
                this.notifications = notifications;
                this.length = data.length;
                this.hydrated = true;
                this.loading  = false;
            }
        },
    
        async load () {
            if (this.loading) return;
    
            this.loading = true;
    
            let data = await this.$nuxt.$axios.$get('/notification/find', {
                progress: false,
                params: {
                    limit: 20,
                    skip: this.notifications.length
                }
            })
            .catch((err) => console.log(err));
    
            if (data) {
                let notifications = data.notifications.map(o => {
                    o.read = !!o.read;
                    return o;
                });
        
                this.notifications.push(...notifications);
                this.length = data.length;
                this.loading = false;
            }
        },

        read ({id, read}) {
            let index = this.notifications.findIndex(t => t.id === id);
            if (index >= 0) this.notifications[index].read = read;
        },
    
        async mark ({id, read}) {
            this.read({id, read});
    
            let data = await this.$nuxt.$axios.$get('/notification/mark', {
                progress: false,
                params: {id}
            })
            .catch((err) => console.log(err));
        },
    
        async readAll () {
            this.markAllread();
    
            let data = await this.$nuxt.$axios.$get('/notification/readAll', {
                progress: false
            })
            .catch((err) => console.log(err));
        },

        markAllread () {
            this.notifications.forEach((notification, index) => {
                this.notifications[index].read = true;
            });

            this.setUnread(0);
        },
    
        async checkUnread () {
            let data = await this.$nuxt.$axios.$get('/notification/checkUnread', {
                progress: false
            })
            .catch((err) => console.log(err));
    
            if (data) this.setUnread(data.count);
        },


        async setBadge (count) {
            if (process.client && 'setAppBadge' in navigator) {
                try {
                    await navigator.setAppBadge(count);
                } catch (error) {
                    console.error('Failed to set app badge:', error);
                }
            }
        },

        async clearBadge() {
            if (process.client && 'clearAppBadge' in navigator) {
                try {
                    await navigator.clearAppBadge();
                } catch (error) {
                    console.error('Failed to clear app badge:', error);
                }
            }
          }
    }
})
